import { Empty, Loading, Loaded } from 'core/state';

export type UserId = number;
export enum TimesheetExcludedUserState {
  Just = 'just',
  Adding = 'adding',
  Removing = 'removing',
}
export type TimesheetExcludedUserMap = Record<
  UserId,
  TimesheetExcludedUserState
>;
export type TimesheetExcludedUsers =
  | Empty
  | Loading
  | Loaded<TimesheetExcludedUserMap>;
